import React from 'react';
import { observer } from 'mobx-react';
import { PropTypes } from 'prop-types';

import AppReviews from '../app-reviews/app-reviews.jsx';
import { RatingsChart } from 'fn-common-ui';

@observer
export class AppDetailReviews extends React.Component {
  static propTypes = {
    rating: PropTypes.number.isRequired,
    reviews: PropTypes.object.isRequired
  };

  renderReviews() {
    const reviewCount = this.props.reviews.length;
    let markup = '';
    if (reviewCount) {
      markup = (
        <div className="app-ratings-reviews">
          <h3 className="app-detail-review-count">
            {`${reviewCount} Review${reviewCount > 1 ? 's' : ''}`}
          </h3>
          <AppReviews reviews={this.props.reviews} />
        </div>
      );
    }
    return markup;
  }

  render() {
    return (
      <div className="review-section">
        <h3 className="as-h4">Ratings & Reviews</h3>
        <section className="app-ratings-chart">
          <RatingsChart
            value={this.props.rating}
            reviewsTotal={this.props.reviews.length}
            reviews={this.props.reviews} />
        </section>
        {this.renderReviews()}
      </div>
    );
  }
}
